import { configureStore } from '@reduxjs/toolkit';

import userSlice from './reducers/user';
import termPlanSlice from './reducers/term-planner';
import appSlice from './reducers/app';

export const store = configureStore({
    reducer: {
        user: userSlice,
        termPlanner: termPlanSlice,
        appState: appSlice,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {user: UserState}
export type AppDispatch = typeof store.dispatch;
